import { WorkplaceDTO } from '@bludata/fc-registry';
import { useQuery } from '@tanstack/react-query';
import { getPoliciesClient } from './ClientServicesCloud';

export const getWorkplaces = async (): Promise<WorkplaceDTO[]> => {
  try {
    const result =
      await getPoliciesClient().getWorkplacesByAuthorizationAsync();

    console.log('getWorkplaces result:', result);

    return result;
  } catch (error) {
    console.error('Error fetching workplaces:', error);
    return [];
  }
};

export const useWorkPlaces = () => {
  return useQuery({
    queryFn: async () => await getWorkplaces(),
    queryKey: ['workplaces'],
    retry: 2,
    retryDelay: 180000,
    gcTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
